export const data = [
  {
    title: "Team Members",
    number: "300+",
  },
  {
    title: "Offices in the US",
    number: "3",
  },
  {
    title: "Transactions analyzed",
    number: "10M+",
  },
];
